import { useNavigate, useSearch } from "@tanstack/react-router";
import type { Key } from "react-aria-components";

export function useTabSearch(defaultValue = "details") {
  const s = useSearch({ strict: false }) as { t?: string };
  const nav = useNavigate();

  const value = s.t || defaultValue;

  return {
    // For radix tabs
    value,
    // biome-ignore lint/suspicious/noExplicitAny: TODO: is this an issue with tanstack router?
    onValueChange: (t: string) => nav({ search: { t }, replace: true } as any),

    // For RAC tabs
    selectedKey: value,
    onSelectionChange: (t: Key) => {
      // biome-ignore lint/suspicious/noExplicitAny: TODO: is this an issue with tanstack router?
      nav({ search: { t }, replace: true } as any);
    },
    variant: "underline" as const,
  };
}
